/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useIsMobile } from '../../hooks';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';

const DataGridCheckbox = React.forwardRef((props, ref) => {
  const { disabledCheckboxTooltip, ...checkboxProps } = props;
  const isMobile = useIsMobile();

  return useMemo(
    () => (
      <Tooltip title={props.disabled ? disabledCheckboxTooltip : ''} classes={{ tooltip: ONBOARDING_TOOLTIP_CLASS_NAME }}>
        <Box
          display="flex"
          justifyContent={isMobile ? 'center' : 'flex-end'}
          width="100%"
          sx={props.disabled ? { pointerEvents: 'all' } : {}}
        >
          <Checkbox
            {...checkboxProps}
            ref={ref}
            disableFocusRipple
            disableRipple
            disableTouchRipple
            id="dataGridCheckbox"
            sx={{
              p: { xs: 0, md: 'inherit' },
              '& .MuiSvgIcon-root': {
                fontSize: { xs: 15, md: 20 },
              },
              zIndex: 1000,
            }}
          />
        </Box>
      </Tooltip>
    ),
    [props.checked, props.className, props.disabled, disabledCheckboxTooltip, isMobile],
  );
});

export default DataGridCheckbox;
